import Game from 'Game';
import GameObject from 'GameObject/GameObject';
import Container from 'Prototype/Container';
import Rope from 'Prototype/Rope';
import Sprite from 'Prototype/Sprite';
import { Texture } from 'Utility/Resource/Texture/Texture';
import Point from 'Utility/Point';
import CardModifier from './CardModifier';
import { Anim } from 'System/Animation/AnimationHelper';
import PIXIResource from 'Utility/Resource/PIXIResource';
import PIXIRenderer from 'System/Render/PIXIRenderer';

export const ROPE_PIECE_CACHE_KEY: string = 'rope_part';
export const TILING_ROPE_CACHE_KEY: string = 'rope_part_POT';
export default class ConnectedModifier extends CardModifier {
    public static ICON_OFFSET: Point = new Point(0, 75);

    public rope: Rope;
    public icon: Sprite;
    public blockedIcon: Sprite;
    public iconContainer: Container;

    onCreate(params: any): void {
        super.onCreate(params);

        this.blockedIcon = GameObject.Instantiate(Sprite, {
            name: 'blocked_icon',
            texture: 'connection_circle_red',
            anchor: new Point(0.5, 0.5),
            scale: new Point(0.5, 0.5),
        });

        this.icon = GameObject.Instantiate(Sprite, {
            name: 'icon',
            texture: 'connection_circle_green',
            anchor: new Point(0.5, 0.5),
            scale: new Point(0.5, 0.5),
            alpha: 0,
        });

        this.iconContainer = GameObject.Instantiate(Container, {
            x: ConnectedModifier.ICON_OFFSET.x,
            y: ConnectedModifier.ICON_OFFSET.y,
        });

        this.iconContainer.addChild(this.blockedIcon);
        this.iconContainer.addChild(this.icon);
    }

    public static async preload(): Promise<void> {
        if (Game.resource.existsOrQueued(TILING_ROPE_CACHE_KEY)) return;

        const ropeFrame = PIXIRenderer.getTexture(ROPE_PIECE_CACHE_KEY);
        const texture = Texture.toPOT(ropeFrame, {
            fitSide: 'width',
        });
        texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
        Game.resource.cacheResource(TILING_ROPE_CACHE_KEY, texture);

        // Needed in case something tries to access the asset via pixi
        PIXI.Texture.addToCache(texture, TILING_ROPE_CACHE_KEY);
    }

    public hideAndDestroy(): void {
        Anim(this.rope, { alpha: 0, duration: 300 }).then(() => {
            this.destroy();
        });
    }
}
